export default ($) => {

	function newTabLinks() {
		let links = document.getElementsByTagName('a');
		for (let l=0; l<links.length; l++) {
			let thisHREF = links[l].getAttribute('href');
			if (thisHREF.includes('#new_tab')) {
				links[l].addEventListener('click', function(e){
					e.preventDefault();
					let linkURL = thisHREF.replace(/#new_tab/ig, '');
					window.open(linkURL, '_blank');
				});
				links[l].addEventListener('keydown', function(e){
					e.preventDefault();
					if (e.keyCode === 13) {
						let linkURL = thisHREF.replace(/#new_tab/ig, '');
						window.open(linkURL, '_blank');
					}
				});
			}
		}
	}

	jQuery(document).ready(function(){
		newTabLinks();
	});
};